//Categories.js
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite/no-important";
import Button from "@material-ui/core/Button";
import Server from "components/Server";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import Cache from "Cache";
import { zoomInDown, zoomOutUp, fadeIn, fadeOut } from "react-animations";
import Typography from "@material-ui/core/Typography";
import { PropagateLoader } from "react-spinners";
import Moon from "../packages/Moon";

const animate = {
	marginLeft: "300px"
};

const styles = {
	root: {
		width: "100%",
		height: "100%"
	}
};

const classes = StyleSheet.create({
	root: {
		width: "100%",
		height: "100%",
		maxWidth: "100%",
		backgroundColor: "rgba(245,245,245,1)",
		boxShadow: "inset -5px 0px 15px rgba(0,0,0,0.2)",
		position: "relative",
		display: "flex",
		flexDirection: "column",
		flexWrap: "nowrap",
		overflow: "hidden",
		zIndex: 4
	},
	categoriesBase: {
		width: "100%",
		height: "100%",
		maxWidth: "100%",
		justifyContent: "start",
		alignItems: "center"
	},
	titleDiv: {
		display: "flex",
		justifyContent: "start",
		alignItems: "center",
		height: "48px"
	},
	li: {
		listStyleType: "none"
	},
	ul: {
		padding: "0px",
		margin: "0px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},
	categoriesScrollDiv: {
		width: "100%",
		height: "calc(100% - 84px)",
		overflowY: "auto"
	},
	categorieButton: {
		width: "200px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		overflow: "hidden"
	},
	categorieButtonFocus: {
		color: "red",
		width: "200px"
	},
	categorieNextButton: {
		minWidth: "50px"
	},
	zoomInDown: {
		animationName: zoomInDown,
		animationDuration: "5s",
		animationFillMode: "forwards"
	},
	loading: {
		padding: "0px",
		margin: "0px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "100%"
	},
	titleButton: {
		minWidth: "30px",
		margin: "0px 5px",
		color: "#777"
	},
	titleText: {
		width: "150px",
		textOverflow: "ellipsis",
		overflow: "hidden"
	}
});

class Categories extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			toggle: false,
			elements: null,
			title: null,
			loading: true,
			searchValue: Moon.use(null),
			searchElements: Moon.use(null)
		};
		this.currentButton = null;
		this.categoriesBase = null;
		this.categories = [];
		this.titles = [];
		this.currentTitle = null;
		this.currentCategory = null;
		this.dragElement = null;
		this.onMoveOnce = false;
	}

	componentDidMount() {
		this.getCategories();
	}

	getCategories() {
		Server.post("/categories/get", null, this.getCategoriesDone.bind(this));
	}

	getCategoriesDone(res) {
		let categories = res.data.categories;
		Cache.categories = categories;
		if (categories != null) {
			if (categories.id == 2 || categories.id == "2")
				this.setFromDefaultCategories(categories);
			else this.setFromRootCategories(categories);
		}
	}

	setFromDefaultCategories(categories) {
		this.currentTitle = categories.name;
		this.setCategoriesTitle(categories.name);
		this.setCategories(categories.children);
	}

	setFromRootCategories(categories) {
		this.categories.push(categories);
		this.titles.push("root");
		this.currentTitle = "root";
		this.setCategoriesTitle(categories.name);
		this.setCategories(categories.children);
	}

	setCategories(categories) {
		console.log(categories);
		let elements = categories.map((e, i) => {
			let ulKey = "ul_key_" + i;
			let categorieKey = "categorie_key_" + i;
			let nextKey = "categorie_next_key_" + i;
			return (
				<ul key={ulKey} className={css(classes.ul)}>
					<Button
						key={categorieKey}
						classes={{ root: css(classes.categorieButton) }}
						//disabled={this.currentButton === e.url ? true: false}
						color={
							this.currentButton === e.id
								? "secondary"
								: "primary"
						}
						onClick={() => {
							this.getCategory(e.id, e.url, e.type, e.name);
						}}
					>
						{e.name}
					</Button>
					{this.renderNextButton(e, nextKey)}
				</ul>
			);
		});

		this.setState({ elements: elements, loading: false });
		this.currentCategory = categories;
	}

	renderNextButton(element, nextKey) {
		let children = element.children;
		return (
			<Button
				classes={{ root: css(classes.categorieNextButton) }}
				key={nextKey}
				onClick={() => {
					this.nextCategories(element.name, children);
				}}
				color="primary"
				disabled={children == null || children.length === 0}
			>
				<NavigateNextIcon />
			</Button>
		);
	}

	nextCategories(title, children) {
		this.categories.push(this.currentCategory);
		this.titles.push(this.currentTitle);
		setTimeout(() => {
			this.setCategoriesTitle(title);
			this.setCategories(children);
		}, 150);
	}

	prevCategories() {
		let beforeCategories = this.categories.pop();
		let beforeTitle = this.titles.pop();
		setTimeout(() => {
			this.setCategoriesTitle(beforeTitle);
			this.setCategories(beforeCategories);
		}, 150);
	}

	setCategoriesTitle(title) {
		let renderTitle = (
			<div className={css(classes.titleDiv)}>
				<Button
					classes={{ root: css(classes.titleButton) }}
					disabled={this.categories.length === 0}
					onClick={() => {
						this.prevCategories();
					}}
				>
					<NavigateBeforeIcon />
				</Button>
				<Typography
					classes={{ root: css(classes.titleText) }}
					variant="body1"
				>
					{title}
				</Typography>
			</div>
		);
		this.setState({ title: renderTitle });
		this.currentTitle = title;
	}

	getCategory(id, url, type, name) {
		if (this.currentButton === id) return;
		this.currentButton = id;
		this.setCategories(this.currentCategory);
		this.props.openCategory(id, url, type, name);
	}

	onOpen() {
		console.log("im open callback!");
	}

	onClose() {
		console.log("im close callback!");
	}

	onPreOpen() {
		console.log("im onPreOpen callback!");
	}

	onPreClose() {
		console.log("im onPreClose callback!");
	}

	renderCategoriesBase() {
		return (
			<div className={css(classes.categoriesBase)}>
				{this.state.title}
				<div className={css(classes.categoriesScrollDiv)}>
					<li className={css(classes.li)}>{this.state.elements}</li>
				</div>
			</div>
		);
	}

	loading() {
		return (
			this.state.loading && (
				<div className={css(classes.loading)}>
					<PropagateLoader
						color={"#123abc"}
						loading={true}
						size={15}
					/>
				</div>
			)
		);
	}

	render() {
		if (this.props.open == false) return null;
		return (
			<div
				id="categories"
				style={{ ...styles.root, ...this.props.style }}
			>
				{this.loading()}
				{this.renderCategoriesBase()}
			</div>
		);
	}
}

export default Categories;
